// extracted by mini-css-extract-plugin
export default {"container":"films_container__JQJeN","inner":"films_inner__bzBda","isContainer":"films_isContainer__1cjIV"};